// extracted by mini-css-extract-plugin
export var hamburger = "B_cX";
export var is_active = "B_cY";
export var hamburger_inner = "B_cZ";
export var hamburger_box = "B_c0";
export var hamburger_accessible = "B_c1";